module.exports = __webpack_public_path__ + "img/IMG_6282.62923b44.jpg";